import { render, staticRenderFns } from "./sklGardenAdList.vue?vue&type=template&id=784c642d&"
import script from "./sklGardenAdList.vue?vue&type=script&lang=js&"
export * from "./sklGardenAdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports